// extracted by mini-css-extract-plugin
export default {"titleContainer":"szizM","toggle":"u6Jzy"};